module.exports = __webpack_public_path__ + "img/chevy-logo.8539b8a2.jpg";